import Vue from 'vue'
import Router from 'vue-router'
import { dms } from './modules/dms'
import { dsp } from './modules/dsp'
import { erp } from './modules/erp'
import { ly } from './modules/ly'
import { fn } from './modules/fn'
import { ai } from './modules/ai'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!) Detail see:
 *                                https://panjiachen.github.io/vue-element-admin-site/zh/guide/essentials/tags-view.html#%E6%B3%A8%E6%84%8F%E4%BA%8B%E9%A1%B9
 * meta : {
    permission_uri: '/dashboard'   control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */
export const homeRoutes = [
  // 预留常量 permission.js 会修改权限的第一条
  { path: '/', redirect: '/user/info' }
]
/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/guide',
    component: Layout,
    hidden: true,
    children: [{
      path: '',
      name: '操作指南',
      meta: { title: '操作指南' },
      component: () => import('@/views/dsp/comment/guide')
    }]
  }, {
    path: '/changelog',
    component: Layout,
    hidden: true,
    children: [{
      path: '',
      name: 'ChangelogShow',
      meta: { title: '更新日志' },
      component: () => import('@/views/dsp/comment/changelog')
    }]
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    redirect: '/user/info',
    children: [{
      path: 'info',
      name: '个人信息',
      component: () => import('@/views/user/info'),
      meta: { title: '个人信息' }
    }, {
      path: 'notice',
      name: 'UserNotice',
      component: () => import('@/views/user/notice'),
      hidden: true,
      meta: {
        title: '消息通知',
        icon: 'log'
      }
    }]
  },
  // 公共路由，针对列表变成图表的一个组件，不需要加入权限控制路由中asyncRoutes
  {
    path: '/echartsTemplate',
    component: Layout,
    hidden: true,
    redirect: '/echartsTemplate/index',
    children: [{
      path: 'index',
      name: '图表详情模板',
      component: () => import('@/views/echartsTemplate/index'),
      meta: { title: '图表详情模板' }
    }]
  }
]

/**
 * adminRoutes
 * level=0的路由
 */
export const adminRoutes = [
  {
    path: '/admin',
    component: Layout,
    redirect: '/admin/datahub-error-log',
    name: 'Admin',
    meta: {
      title: '管理员',
      icon: 'admin'
    },
    children: [{
      path: 'datahub-error-log',
      name: 'DatahubErrorLog',
      component: () => import('@/views/admin/datahubErrorLog'),
      meta: {
        title: '错误日志',
        icon: 'error-log'
      }
    }, {
      path: 'out-log',
      name: 'AdminOutLog',
      component: () => import('@/views/admin/outLog'),
      meta: {
        title: '对外日志管理',
        icon: 'log'
      }
    }, {
      path: 'log',
      name: 'AdminLog',
      component: () => import('@/views/admin/log'),
      meta: {
        title: '日志管理(弃用)',
        icon: 'log'
      }
    }, {
      path: 'es-log',
      name: 'AdminEsLog',
      component: () => import('@/views/admin/esLog'),
      meta: {
        title: '日志管理',
        icon: 'elasticsearch'
      }
    }, {
      path: 'leader-group',
      name: 'LeaderGroup',
      component: () => import('@/views/admin/leaderGroup'),
      meta: {
        title: '负责人分组',
        icon: 'retain'
      }
    }, {
      path: 'media-type',
      name: 'MediaType',
      component: () => import('@/views/admin/mediaType'),
      meta: {
        title: '媒体类型',
        permission_uri: '/admin/media-type',
        icon: 'media-type'
      }
    }, {
      path: 'media-developer',
      name: 'MediaDeveloper',
      component: () => import('@/views/admin/mediaDeveloper'),
      meta: {
        title: '开发者管理',
        permission_uri: '/admin/media-developer',
        icon: 'company'
      }
    }, {
      path: 'plan-timing',
      name: 'PlanTiming',
      component: () => import('@/views/admin/PlanTiming'),
      meta: {
        title: '定时计划',
        permission_uri: '/admin/plan-timing',
        icon: 'plan'
      }
    }, {
      path: 'announcement',
      name: 'announcement',
      component: () => import('@/views/admin/announcement'),
      meta: {
        title: '公告',
        icon: 'announcement'
      }
    },
    {
      path: 'change-log',
      name: 'ChangeLog',
      component: () => import('@/views/admin/changeLog'),
      meta: {
        title: '更新日志',
        icon: 'log'
      }
    },
    {
      path: 'banners',
      name: 'Banners',
      component: () => import('@/views/admin/banners'),
      meta: {
        title: '中央广播',
        icon: 'log'
      }
    },
    {
      path: 'guide-list',
      name: 'GuideList',
      component: () => import('@/views/admin/guideList'),
      meta: {
        title: '指南列表',
        permission_uri: '/operation/guide',
        icon: 'log'
      }
    },
    {
      path: 'agency-permission',
      name: 'AgencyPermission',
      component: () => import('@/views/admin/agencyPermission'),
      meta: {
        title: '对外后台渠道权限',
        icon: 'user'
      }
    }
    ]
  }
]

export const asyncRoutesDMS = dms

export const asyncRoutesDSP = dsp

export const asyncRoutesERP = erp

export const asyncRoutesLY = ly

export const asyncRoutesAI = ai

export const asyncRoutesFN = fn

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
